export const Label = {
  JSD: "Junior Software Developer",
  BDE: "Business Development Executive",
  HR: "Human Resource",
  PA: "Personal Assistant",
  MSD: "Mean Stack Developer",
};
